import { useEffect } from 'react';
import useRefreshToken from './useRefreshToken';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Navigate } from 'react-router-dom';
import { authDetailsType } from './http-server';

export const getCurrentAuth = () => {
  const localAuth: any = localStorage.getItem('auth');
  const auth: authDetailsType = localAuth ? JSON.parse(localStorage.getItem('auth') || '') : {};
  const authreturn = {
    access: auth.access?.token,
    refresh: auth.refresh?.token
  };
  return authreturn;
};

export const Logout = () => {
  localStorage.removeItem('auth');
};

const useAxiosPrivate = (axiosInstance: AxiosInstance) => {
  const refresh = useRefreshToken();
  // var auth = useTypedSelector(getAuthState, shallowEqual);
  // const dispatch = useDispatch();
  const auth = getCurrentAuth();
  useEffect(() => {
    const requestIntercept = axiosInstance.interceptors.request.use(
      // @ts-ignore: Unreachable code error
      (config: AxiosRequestConfig) => {
        if (!config.headers!['Authorization']) {
          config.headers!['Authorization'] = `bearer ${auth?.access}`;
        }
        return config;
      },
      (error: any) => {
        Promise.reject(error);
      }
    );

    const responseIntercept = axiosInstance.interceptors.response.use(
      (response: any) => response,
      async (error: any) => {
        const prevRequest = error?.config;
        if (
          (error?.response?.status === 403 || error?.response?.status === 401) &&
          !prevRequest?._retry
        ) {
          prevRequest._retry = true;
          const newaccess = await refresh();
          if (!newaccess) {
            // dispatch(logout());
            Logout();
          } else {
            axiosInstance.defaults.headers.common['Authorization'] = `bearer ${newaccess}`;
            prevRequest.headers['Authorization'] = `bearer ${newaccess}`;
            return axiosInstance(prevRequest);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.request.eject(requestIntercept);
      axiosInstance.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosInstance;
};

export default useAxiosPrivate;
